<template>
	<div id="app">
		<router-view></router-view>		
	</div>
</template>

<script>
var moment = require('moment')
moment.locale('pt-br');
import { Bus } from './event-bus.js'
import i18n from "@/plugins/i18n";
export default {
	name: 'app',
	metaInfo: {
	  title: 'Repense Game - Huddle Brasil',
	  link : [
		  { rel: 'favicon', href: 'huddle-favicon.png' }
	  ]
    },
	data: function(){
		return{colors: {}}
	},
	async created(){  

		const language = localStorage.getItem("language")
		i18n.locale = language ? language : "pt-br"
		let soloGame = this.$store.getters.getSoloGame
        let gameSetId = localStorage.getItem('gameSetId')
		let self = this
		let route = this.$route
		if(route.meta.redirect || route.meta.redirect == false) return
		if(route.name == 'RedirectExternal' || route.matched[0].path == '/feedback') return
		
		if(route.name != 'RedirectAuth' && route.name != 'Extract'){
			if(soloGame.length > 0 && soloGame[soloGame.length - 1].status == 'inprogress'){
				this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`)
					.then(response => {
						let now = moment(response.body.now)

						self.$store.commit('setNowState', moment(now))
						// self.$router.push('/solo-game')
						// console.log("Router Push => Solo Game")
					})
			}
			if(gameSetId){
				this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/${gameSetId}`)
					.then(response => {
						let score = response.body.score
						self.$store.commit('setScoreState', score)
						self.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`)
							.then(response => {
									let now = moment(response.body.now)
									self.$store.commit('setNowState', now)
									let soloGames = response.body.soloGames
									let lastSolo = self.defineLastSolo(soloGames)
									self.$store.commit('setBetState', lastSolo.bet)
									let initGame = moment(lastSolo.createdAt)
									self.$store.commit('setSoloGameRequest', response.body.soloGames)
									let secondsDiff = initGame.diff(now, "seconds");
									localStorage.setItem('soloGameId', lastSolo.id)
									localStorage.setItem('secondsDiff', secondsDiff)
									Bus.$emit('alterStatus', lastSolo.status)
									Bus.$emit('saveSoloGame', soloGames)
									if(lastSolo.status == 'inprogress'){
										let requestedHints = lastSolo.requestedHints
										let attemptsTamanho = lastSolo.attempts

										// self.$router.push('/solo-game')
										// console.log("Router Push => Solo Game")
										self.$store.commit('subScoreState', lastSolo.bet)

										if(secondsDiff < -300){
											let points = (- 300 - secondsDiff)
											self.$store.commit('subScoreState', points)
										}
										// if(requestedHints){
										// 	self.$store.commit('subScoreState', (requestedHints.length * 500))
										// }
										// if(attemptsTamanho && attemptsTamanho.length > 3){
										//     self.$store.commit('subScoreState', ((attemptsTamanho.length - 3) * 50))
										// }
									}else{
										if(soloGames.length == 4 && soloGames[3].status != 'inprogress'){
											// self.$router.push('/dashboard')
											// console.log("Router Push => Dashboard")
											return
										}
										if(lastSolo.status != 'inprogress'){
											// self.$router.push('/')
											// console.log("Router Push => /")
										}
									}
									localStorage.setItem('localScore', this.$store.getters.getGameData('currentScore'))
							}).catch(error => {
								//TODO: make a error message showing up instead console.log error
								//console.log(error)
							})
					})
			}else{
				this.$store.dispatch('getSoloGame')
				let player = JSON.parse(localStorage.getItem('player'))
				let workspaceId = localStorage.getItem('workspaceId')
				// console.log('Player :', player)
				try {
					let gameSetIdReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/`,{
                        "userId": player.uid,
                        "workspaceId": workspaceId,
						"status": "inprogress",
						"qtMaxSoloGames": 4
					},{
						headers: {
							'Content-Type': 'application/json'
						}
					})
					// console.log(gameSetIdReq.body.id)
					localStorage.setItem('gameSetId',gameSetIdReq.body.id)

				} catch (error) {
					//TODO: make a error message showing up instead console.log error
					// console.error(error)
					// console.error('Erro ao criar o GameSetId: ', error.response.data.error)
				}
				if(player){
					let token = player.token
					this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS}/verify?tokenId=${token}`)
						.then(response => {
							let body = response.body
							if(body.code){
								//TODO: message showing up instead console.log
								// console.log('usuario não autenticado')
								// location.href = `${process.env.VUE_APP_HOST_AUTHENTICATION}/`
							}else{
								//TODO: message showing up instead console.log
								// console.log('usuario autenticado')
							}
						})
				}else{
					location.href = `${process.env.VUE_APP_HOST_AUTHENTICATION}/`
				}
			}
		}
		if(route.name == 'Extract'){
			if(gameSetId){
				this.$http.get(`https://us-central1-repense-game-cdad7.cloudfunctions.net/api/game-sets/${gameSetId}`)
					.then(response => {
						self.$store.commit('setScoreState', response.body.score)
					})
			}
		}
	},
	mounted(){
		setTimeout(() => {
			this.colors = JSON.parse(localStorage.getItem("colors"));
			const body = document.querySelector('body')
			if(this.colors) body.style.background = this.colors[this.colors.theme].to  
			// console.log("COLORS =>: ", this.colors)
		}, 2000);
	},
	methods : {
		defineLastSolo(soloGames){
            if(soloGames.length < 2) return soloGames[0]
            let lastSolo = soloGames.reduce((a, b) => {
                return a.createdAt > b.createdAt ? a : b
            })
            return lastSolo
        }
	}, 
	metaInfo: {
		title: 'Repense game - Huddle Brasil',
		link:	{ rel: 'favicon', href: '<%= BASE_URL %>favicon.ico' }
  	} 
}
</script>

<style lang="scss">


	body{
		overflow-y: hidden;
	}
	@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100;400;700;900&display=swap');
	@import 'assets/scss/colors';
	@import 'assets/scss/reset';
	@import 'assets/scss/main';

	*{
		font-family: Raleway;
	}
	.bold{
		font-weight: bold;
	}
</style>
